import Axios from 'axios';
import AuthorizedRequest from './authorized-request';

const Request = Axios.create({
  baseURL: 'https://maps.googleapis.com/maps/api/',
});

const API_KEY = process.env.VUE_APP_GMAPS_API_KEY;
const STATIC_URL = process.env.VUE_APP_STATIC_URL;
const BRAND_PREFIX = process.env.VUE_APP_BRAND_PREFIX
const staticBucket = `c/${BRAND_PREFIX}`

export default class UtilApi {
  static async getCoords(address) {
    return Request.get(`/geocode/json?address=${address[0]}&key=${API_KEY}`);
  }

  static async uploadStaticFile(data) {
    return AuthorizedRequest.post(`${STATIC_URL}${staticBucket}`, data.formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: event => data.listener(event, data.file),
    });
  }

  static async updateStaticFile(data) {

    const fixedUrl = data.url.replace(
      process.env.VUE_APP_STATIC_URL,
      `${process.env.VUE_APP_STATIC_URL}c/`
    );

    return AuthorizedRequest.put(fixedUrl, data.formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: event => data.listener(event, data.file)
    })
  }

  static async removeStaticFile(url) {
    const fixedUrl = url.replace(
      process.env.VUE_APP_STATIC_URL,
      `${process.env.VUE_APP_STATIC_URL}c/`
    );
    return AuthorizedRequest.delete(fixedUrl);
  }
}
